/** @file Linear interpolation helpers. */

/** @param {number} t */
export function clamp01(t) {
  if (t < 0) {
    return 0;
  }
  if (t > 1) {
    return 1;
  }
  return t;
}

/**
 * @param {{x:number,y:number}} a
 * @param {{x:number,y:number}} b
 * @param {number} t  in [0,1]; out-of-range is clamped
 * @returns {{x:number,y:number}}
 */
export function lerpPoint(a, b, t) {
  const k = clamp01(t);
  return {
    x: a.x + (b.x - a.x) * k,
    y: a.y + (b.y - a.y) * k,
  };
}
